import {FC} from 'react'
import {Card} from 'react-bootstrap'
import bgImage from '../../assets/img/bg.png'

type Props = {
  data: any
  isMobile?: boolean
}

const Page4: FC<Props> = ({data, isMobile = false}) => {
  return (
    <Card className='h-100 border-0 bg-light bg-opacity-75 shadow-sm'>
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          height: '100%',
        }}
        className={isMobile ? 'p-8' : 'p-14'}
      ></div>
    </Card>
  )
}

export default Page4